import { createStyles, Image, Title, Text, Button, SimpleGrid } from '@mantine/core';
import { default as NotFoundImage } from '../../assets/not-found.svg'
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const useStyles = createStyles((theme) => ({

  root: {
    width:'100%',
    height:'100%',
    margin:'0 auto',
    display:'flex',
    alignItems:'center',
    maxWidth:1350,
    justifyContent:'center',
    padding: '125px 50px',
    [theme.fn.smallerThan('md')]: {
        padding: '25px 25px',
      },
  },

  textWrapper:{
    display:'flex',
    alignItems:'center'
  },

  title: {
    fontWeight: 700,
    fontSize: '80px',
    lineHeight:'90px',
    marginBottom: theme.spacing.md,
    [theme.fn.smallerThan('md')]: {
      fontSize: 32,
    },
  },

  homeButton: {
    width:'250px',
    [theme.fn.smallerThan('md')]: {
      width: '100%',
    },
  },

  mobileImageContainer: {
    [theme.fn.largerThan('md')]: {
      display: 'none',
    },
  },

  desktopImage: {
    display:'flex',
    alignItems:'center',
    [theme.fn.smallerThan('md')]: {
      display: 'none',
    },
  },
}));

const NotFound = () => {

  const { classes } = useStyles();

  return (
    <>
      <Helmet>
          <title>Page not found | Roundtable</title>
          <meta name='description' content="Roundtable's AI-assisted survey data cleaning and fraud prevention time saves market research agencies and panels roughly 70% of their time doing manual quality checks." />
      </Helmet>
      <div className={classes.root}>
        <SimpleGrid spacing={50} cols={2} breakpoints={[{ maxWidth: 'md', cols: 1, spacing: 40 }]}>
          <div className={classes.mobileImageContainer}>
              <Image src={NotFoundImage}  />
          </div>
          <div className = {classes.textWrapper}>
              <div>
                  <Title className={classes.title}>Page not found!</Title>
                  <Text size="xl">
                      We can't find the page you're looking for. You may have mistyped the address or the
                      page may have been moved to another URL.
                  </Text>
                  <Button component = {Link} to = '/' variant="outline" size="xl" mt="xl" className={classes.homeButton}>
                      Home
                  </Button>
              </div>
          </div>
          <div className={classes.desktopImage}>
                      <Image src={NotFoundImage}  />
          </div>
        </SimpleGrid>
      </div>
    </>
  );
}

export default NotFound